<template>
  <div class="text-[14px] leading-[20px] text-gray-800">
    <p>{{ content.subtitle }}</p>

    <div class="mt-5 rounded-[12px] border border-[#f2f0ee] bg-[#f9f9fa] p-5">
      <p class="font-medium">{{ content.cardLabel }}</p>
      <ul class="mt-4 flex flex-col gap-3.5">
        <li
          v-for="(bullet, index) in content.bullets"
          :key="index"
          class="flex gap-2.5"
        >
          <span aria-hidden="true">&bull;</span>
          <span>{{ bullet }}</span>
        </li>
      </ul>
    </div>

    <div v-if="hasOutstandingBalance" class="mt-5">
      <p>{{ content.feesIntro }}</p>
      <p class="mt-5">
        To {{ content.payVerb }}, pay your
        <span class="font-medium"
          >outstanding balance of {{ outstandingBalance }}</span
        >.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { closureContent, type ClosureMode } from '../content'
import { useOutstandingBalance } from '../useOutstandingBalance'

const props = defineProps<{ mode: ClosureMode }>()

const content = closureContent[props.mode].info
const { hasOutstandingBalance, outstandingBalance } = useOutstandingBalance()
</script>
